// extracted by mini-css-extract-plugin
module.exports = {"FloatingBanner":"FloatingBanner_FloatingBanner__zjjiw","highlight":"FloatingBanner_highlight__cRmqs"};